import VueI18n from 'vue-i18n';
import { computed, getCurrentInstance } from 'vue';

let i18nInstance: VueI18n | undefined;
export function createI18n(options: VueI18n.I18nOptions) {
	i18nInstance = new VueI18n(options);
	return i18nInstance;
}

export function useI18n() {
	// When called inside a component setup, prefer the Vue instance's $i18n over the
	// module-level singleton. The singleton is shared across concurrent SSR requests and
	// can be overwritten by a request for a different locale while another request is
	// still rendering, causing wrong-language text for components that call useI18n().
	const vm = getCurrentInstance();
	const i18n = (vm?.proxy?.$i18n as VueI18n | undefined) ?? i18nInstance;

	if (!i18n) throw new Error('vue-i18n not initialized');

	const locale = computed({
		get: () => i18n.locale,
		set: v => (i18n.locale = v),
	});

	return {
		locale,
		t: i18n.t.bind(i18n),
		tc: i18n.tc.bind(i18n),
		d: i18n.d.bind(i18n),
		te: i18n.te.bind(i18n),
		n: i18n.n.bind(i18n),
		setLocaleMessage: i18n.setLocaleMessage.bind(i18n),
	};
}
